import { oneBtnDialog } from '@/utils/utils';

const validators  = () => {
    const validatePhoneNumber = async (input) => {
        if (!input) {
            await oneBtnDialog('휴대폰 번호 미기입', '휴대폰 번호를 입력해 주세요.', false);
            return false;
        } 
        if(!input.startsWith('01') || input.length < 12) {
            await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
            return false;
        } 
        if(input.startsWith('010-0')) {
            await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
            return false;
        }
        if(input.startsWith('010') && input.length < 13) {
            await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
            return false;
        }
        return true;
    }

    return {
        validatePhoneNumber,
    }
}

export default validators;